export const FULL_SCREEN_BTN = "fullsize"
